import { render } from "./CarouselContent.vue?vue&type=template&id=47dceb01"
import script from "./CarouselContent.vue?vue&type=script&lang=js"
export * from "./CarouselContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__